import React from 'react';
import {
  ToggleButton,
  makeStyles,
  mergeClasses,
} from '@fluentui/react-components';
import {
  Filter20Regular,
} from '@fluentui/react-icons';

const useStyles = makeStyles({
  toggleButton: {
    minWidth: 'unset',
  },
});

export const FilterToggleButton = (props) => {
  const {
    i18n,
    className,
    onClick,
    checked,
  } = props;

  const classes = useStyles();
  const text = i18n.getString(_TL_('Filter'));

  return (
    <div className={className}>
      <ToggleButton
        key="filter"
        className={mergeClasses('filter-toggle-button', classes.toggleButton)}
        checked={checked}
        icon={<Filter20Regular />}
        onClick={() => {
          onClick();
        }}
      >
        {text}
      </ToggleButton>
    </div>
  );
};
